import React from "react"
import { motion } from "framer-motion"
import {
  FaSpa,
  FaUserCheck,
  FaLeaf,
  FaHeart,
} from "react-icons/fa"

import SectionTitle from "../common/SectionTitle"
import Button from "../common/Button"

export default function WhyChooseUs() {
  const features = [
    {
      id: 1,
      icon: <FaSpa />,
      title: "Environnement De Luxe",
      description:
        "Des espaces élégants conçus pour créer une expérience de bien-être paisible et haut de gamme.",
    },

    {
      id: 2,
      icon: <FaUserCheck />,
      title: "Thérapeutes Experts",
      description:
        "Des spécialistes professionnels dédiés aux soins personnalisés et à la détente.",
    },

    {
      id: 3,
      icon: <FaLeaf />,
      title: "Traitements Naturels",
      description:
        "Thérapies de bien-être haut de gamme utilisant des produits et des techniques naturels de haute qualité.",
    },

    {
      id: 4,
      icon: <FaHeart />,
      title: "Relaxation Complète",
      description:
        "Une expérience de spa holistique axée sur l'équilibre, le confort et le rajeunissement.",
    },
  ]

  return (
    <section className="relative py-20 lg:py-28 bg-[#111111] overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-72 h-72 bg-[#b8955d] rounded-full blur-3xl" />

        <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#b8955d] rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <SectionTitle
          subtitle="Pourquoi Nous Choisir"
          title="Expériences Exceptionnelles de Bien-être et de Spa de Luxe"
          description="Nous combinons des soins haut de gamme, une expertise pointue et une atmosphère relaxante pour vous offrir des expériences de bien-être inoubliables."
          light={true}
        />

        {/* Features */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
          {features.map((feature, index) => (
            <motion.article
              key={feature.id}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: index * 0.15 }}
              viewport={{ once: true }}
              className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-[28px] p-8 hover:bg-white/10 transition-all duration-500"
            >
              {/* Icon */}
              <div className="w-16 h-16 rounded-2xl bg-[#b8955d] text-white text-2xl flex items-center justify-center shadow-lg">
                {feature.icon}
              </div>

              {/* Title */}
              <h3 className="text-2xl font-semibold text-white mt-6">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-gray-300 leading-relaxed mt-4 text-sm">
                {feature.description}
              </p>
            </motion.article>
          ))}
        </div>

        {/* Bottom Section */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="mt-20 bg-[#1b1b1b] rounded-[35px] overflow-hidden shadow-2xl"
        >
          <div className="grid lg:grid-cols-2 items-center">
            {/* Image */}
            <div className="h-full">
              <img
                src="/images/why-choose-spa.jpg"
                alt="Expérience de bien-être spa de luxe"
                loading="lazy"
                className="w-full h-full object-cover min-h-[400px]"
              />
            </div>

            {/* Content */}
            <div className="p-10 lg:p-14">
              <span className="inline-block text-[#d6b57b] uppercase tracking-[4px] text-sm mb-5">
               Le Bien-être Redéfini
              </span>

              <h3 className="text-3xl md:text-4xl font-bold text-white leading-tight">
                Détendez-vous, Ressourcez-vous et Rajeunissez en toute Sérénité
              </h3>

              <p className="text-gray-300 leading-relaxed mt-6">
                Chaque détail de notre centre de spa est conçu pour créer une escapade luxueuse où votre bien-être est notre priorité.
                Découvrez des soins qui rétablissent l'harmonie de votre corps et de votre esprit.
                ✔ Piscine intérieure chauffée
✔ Espace bien-être et remise en forme moderne
✔ Hammam de luxe
✔ Massothérapeutes professionnels
              </p>

              {/* CTA */}
              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <Button
                  to="/à propos"
                  size="lg"
                  variant="primary"
                  ariaLabel="Découvrez notre spa"
                >
                  En Savoir Plus
                </Button>

                <Button
                  href="https://wa.me/21697902051"
                  size="lg"
                  variant="outline"
                  ariaLabel="Réservez votre rendez-vous au spa"
                >
                  Réservez Maintenant
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}